// extracted by mini-css-extract-plugin
module.exports = {"form-inputs":"Input_form-inputs__2Egg-","form-errors":"Input_form-errors__6EAcb","error":"Input_error__2rwm3"};